export default "__VITE_ASSET__39f3fa54__"